import { useTrackProject } from "hooks/useRequest/project/projectRequest"
import { useRouter } from "next/router"
import { useEffect } from "react"
import { ITrackProject } from "rules/interface/project/track.interface"
import lastProject from "services/last-project"
import trackProjectSerivce from "services/track-project.serivce"




const TrackSession = () => {
    const router = useRouter()
    const { mutate } = useTrackProject()


    useEffect(() => {
        let time: number = 0
        let interval = null
        const projectId = lastProject.getId()

        // interval time stand in page
        interval = setInterval(() => {
            time += 7

            const trackData: ITrackProject = {
                url: location.pathname,
                timeSpent: time,
                ...(location.search && {
                    parameters: decodeURI(location.search),
                })
            }

            trackProjectSerivce.setTrack(trackData)

            if (projectId) {
                mutate({
                    id: projectId,
                    data: {
                        trackingData: [trackData]
                    }
                })
            }
        }, 7000)

        time = 0

        return () => {
            // zero time stand
            time = 0
            // clear standTime interval
            clearInterval(interval)
        }
    }, [router, lastProject.getId()])


    return <></>
}

export default TrackSession